import React from 'react';
import styled from 'styled-components';
import Text from 'components/Text';
import { COLOR } from 'config';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import image from '../images/buy.png';
import Title from './Title';
import Card from './Card';
import Button from './Button';
import { ImageCardContainer } from './ImageCard';

const StyledText = styled(Text)`
  line-height:2.35rem;
`;

const StyledButton = styled(Button)`
  //color:${COLOR.white};
  background-color:${COLOR.base};
  border-radius:5px;
  padding: 12px 24px;
  padding-bottom: 13px;
  margin-top: 14px;
  color: white;
  line-height: 1 !important;
  font-weight: bold;
  &:hover{
    background-color:${COLOR.base};
  }
`;

const BuyingSkycoin = () => {
  const icon = (<ImageCardContainer
    image={image}
    height="400"
    width="480"
    backgroundColor={COLOR.base}
  />);

  return (
    <Card image={icon} mb={'0rem'} flexDirection="row-reverse">
      <Title id="landing.skycoin.buying.title" />
      <StyledText>
        <FormattedHTMLMessage id="landing.skycoin.buying.description" />
      </StyledText>
      <StyledButton to="https://www.skycoin.com/buy/" width={['100%', 200, 200]}>
        <FormattedMessage id="landing.skycoin.buying.button" />
      </StyledButton>
    </Card>
  );
};

export default BuyingSkycoin;



// WEBPACK FOOTER //
// ./src/components/SkycoinLanding/components/BuyingSkycoin.js